<h3 mat-dialog-title>{{ data?.title }}</h3>
<div class="content" mat-dialog-content>
  <p *ngIf="data?.message" [innerHTML]="data?.message"></p>
  <ng-container *ngIf="data.messages">
    <p *ngFor="let message of data.messages" [innerHTML]="message"></p>
  </ng-container>
</div>

<div mat-dialog-actions class="button-footer">
  <button
    autofocus
    goab-button
    buttonType="primary"
    [mat-dialog-close]="true"
    data-cy="confirm-yes"
    class="goab-button"
  >
    {{ data?.confirmLabel || 'Yes' }}
  </button>
  <button goab-button buttonType="tertiary" data-cy="confirm-no" [mat-dialog-close]="false">
    {{ data?.cancelLabel || 'No ' }}
  </button>
</div>

<div class="alert-icon">
  <img class="icon-image error" src="/assets/callout-emergency.svg" />
  <img class="icon-image warning" src="/assets/callout-warning.svg" />
  <img class="icon-image info" src="/assets/callout-info.svg" />
  <img class="icon-image success" src="/assets/callout-success.svg" />
</div>
